const FPS = 60;

// Sine
const easeInSine = (x) => 1 - Math.cos((x * Math.PI) / 2);
const easeOutSine = (x) => Math.sin((x * Math.PI) / 2);
const easeInOutSine = (x) => -(Math.cos(Math.PI * x) - 1) / 2;

// Cubic
const easeInQuad = (x) => x * x;
const easeOutQuad = (x) => 1 - (1 - x) * (1 - x);
const easeInOutQuad = (x) => (x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2);

// Cubic
const easeInCubic = (x) => x * x * x;
const easeOutCubic = (x) => 1 - Math.pow(1 - x, 3);
const easeInOutCubic = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);

// Quart
const easeInQuart = (x) => x * x * x * x;
const easeOutQuart = (x) => 1 - Math.pow(1 - x, 4);
const easeInOutQuart = (x) => (x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2);

// Quint
const easeInQuint = (x) => x * x * x * x * x;
const easeOutQuint = (x) => 1 - Math.pow(1 - x, 5);
const easeInOutQuint = (x) => (x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2);

// Expo
const easeInExpo = (x) => (x === 0 ? 0 : Math.pow(2, 10 * x - 10));
const easeOutExpo = (x) => (x === 1 ? 1 : 1 - Math.pow(2, -10 * x));
const easeInOutExpo = (x) => (x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2);

// Circ
const easeInCirc = (x) => 1 - Math.sqrt(1 - Math.pow(x, 2));
const easeOutCirc = (x) => Math.sqrt(1 - Math.pow(x - 1, 2));
const easeInOutCirc = (x) => (x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2);

// Back
const easeInBack = (x) => {
    const c1 = 1.70158;
    const c3 = c1 + 1;
    return c3 * x * x * x - c1 * x * x;
};
const easeOutBack = (x) => {
    const c1 = 1.70158;
    const c3 = c1 + 1;
    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
};
const easeInOutBack = (x) => {
    const c1 = 1.70158;
    const c2 = c1 * 1.525;
    return x < 0.5 ? (Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2)) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
};

// Elastic
const easeInElasticfunction = (x) => {
    const c4 = (2 * Math.PI) / 3;
    return x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4);
};
const easeOutElastic = (x) => {
    const c4 = (2 * Math.PI) / 3;
    return x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
};
const easeInOutElastic = (x) => {
    const c5 = (2 * Math.PI) / 4.5;
    return x === 0
        ? 0
        : x === 1
        ? 1
        : x < 0.5
        ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2
        : (Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5)) / 2 + 1;
};

// Bounce
const easeInBounce = (x) => 1 - easeOutBounce(1 - x);
const easeOutBounce = (x) => {
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
const easeInOutBounce = (x) => (x < 0.5 ? (1 - easeOutBounce(1 - 2 * x)) / 2 : (1 + easeOutBounce(2 * x - 1)) / 2);

//
//
//
//
//

export const easings = {
    // Sine
    easeInSine,
    easeOutSine,
    easeInOutSine,

    // Quad
    easeInQuad,
    easeOutQuad,
    easeInOutQuad,

    // Cubic
    easeInCubic,
    easeOutCubic,
    easeInOutCubic,

    // Quart
    easeInQuart,
    easeOutQuart,
    easeInOutQuart,

    // Quint
    easeInQuint,
    easeOutQuint,
    easeInOutQuint,

    // Expo
    easeInExpo,
    easeOutExpo,
    easeInOutExpo,

    // Circ
    easeInCirc,
    easeOutCirc,
    easeInOutCirc,

    // Back
    easeInBack,
    easeOutBack,
    easeInOutBack,

    // Elastic
    easeInElasticfunction,
    easeOutElastic,
    easeInOutElastic,

    // Bounce
    easeInBounce,
    easeOutBounce,
    easeInOutBounce,

    //
    createBezierEasing: (p1: number, p2: number) => (t: number) => {
        var c = 3 * p1,
            b = 3 * (p2 - p1) - c,
            a = 1 - c - b,
            t2 = t * t;
        return a * t2 * t + b * t2 + c * t;
    },
};

//-----------
export const Transition = function (easing, duration: number) {
    const self = this;
    let startTime = 0;
    let t = 0;
    let on_change = null;

    self.startPos = 0;
    self.endPos = 0;
    self.busy = false;

    if (typeof easing === "string") easing = easings[easing];
    if (!easing) easing = easings.createBezierEasing(0, 1);

    self.start = function (start: number, end: number, onChange: (value: number) => void) {
        startTime = Date.now();
        self.startPos = start;
        self.endPos = end;
        t = 0;
        on_change = onChange;
        if (!self.busy) tick();
    };

    const tick = function () {
        if (!on_change) return;
        var t = (Date.now() - startTime) / duration;
        self.busy = true;
        //---
        var v = t >= 1 ? self.endPos : self.startPos + (self.endPos - self.startPos) * easing(t);
        on_change(v);
        self.busy = t < 1;
        if (self.busy) requestFrame(tick);
    };
};

const requestFrame = (function () {
    return (
        window.requestAnimationFrame ||
        window["webkitRequestAnimationFrame"] ||
        window["mozRequestAnimationFrame"] ||
        window["oRequestAnimationFrame"] ||
        window["msRequestAnimationFrame"] ||
        function (func) {
            window.setTimeout(func, 1000 / FPS);
        }
    );
})();
